import { SVGProps } from 'react'

export const NoneIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#a)">
			<path
				d="M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m0 2a9.95 9.95 0 0 1 6.324 2.262L4.262 18.324A9.992 9.992 0 0 1 12 2m0 20a9.95 9.95 0 0 1-6.324-2.262L19.738 5.676A9.993 9.993 0 0 1 12 22"
				fill="#0A0909"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
)
